import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataChangeService {
  private dataChangedSubject = new BehaviorSubject<boolean>(false);
  public dataChanged$ = this.dataChangedSubject.asObservable();

  constructor() {}

  notifyDataChanged(): void {
    this.dataChangedSubject.next(true);
  }

  resetDataChanged(): void {
    this.dataChangedSubject.next(false);
  }
}

